import React from 'react';
import Admissiondayheader from '../../components/AdmissionsDay/AdmissionDayheadr';
import AboutQut from '../../components/AdmissionsDay/AboutQut';
import WhyChoose from '../../components/AdmissionsDay/WhyChoose';
import PopularCourses from '../../components/AdmissionsDay/PopularCourses';
import Whystudycontry from '../../components/AdmissionsDay/WhyStudyinCountry';
import StudiesFAQ from '../../components/AdmissionsDay/StudiesFAQ';
import { useEffect } from 'react';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import EduFairStudentTestimonials from '../../components/OverseasEdutionFair/eduFairStudTestimonials';
import EduFairKcByNumber from '../../components/OverseasEdutionFair/eduFairKcByNumber';
import WhyChoosKcStudyAbroad from '../../components/OverseasEdutionFair/eduFairWhyChoosekc';
import EduFairFooterCommon from '../../components/OverseasEdutionFair/eduFairFooter';
import Benefitsofattentadmissionday from '../../components/AdmissionsDay/BenefitsOfAdmissionsDay';
import ParticipatingUniversities from './ParticipatingUniversities/ParticipatingUniversities';
import GrabChanceSection from '../../components/OverseasEdutionFair/GrabChanceSection';
import AccomplishSection from '../../components/OverseasEdutionFair/AccomplishSection';
import HowToAttendEvent from './HowToAttendEvent';
import { useRouter } from 'next/router';
import DelegatesSection from './DelegatesSection/DelegatesSection';

const AdmissionsDayLanding: React.FC = (props: any) => {
  const router = useRouter();
  const eventData = props.pageData[0];

  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty(
      '--event-bgcolor',
      eventData?.bannerSection?.sectionBgColor || '#6C48F0'
    );
  }, []);

  return (
    <>
      <MetaTagsComp {...eventData.meta} />
      {eventData?.bannerSection && (
        <div>
          <Admissiondayheader
            data={eventData?.bannerSection}
            jotformId={eventData?.meta?.jotforms[0]?.jotformid}
            externalLink={eventData?.externalLink} 
          />
        </div>
      )}

      {router.asPath.includes('/company/')
        ? eventData?.whyStudySection && (
          <div>
            <Whystudycontry whystudydata={eventData?.whyStudySection}
              jotformId={eventData?.meta?.jotforms[0]?.jotformid}  externalLink={eventData?.externalLink}/>
          </div>
        )
        : eventData?.benefitsSection && (
          <div>
            <Benefitsofattentadmissionday
              benefitdata={eventData?.benefitsSection}
            />
          </div>
        )}

      {eventData?.participatingSection?.length > 0 && (
        router.asPath.includes('/admissions-day/')
          ? (
            <div>
              <DelegatesSection universitydata={eventData?.participatingSection}
                univertitle={eventData?.participatingSectionTitle}
                universitybackcolor={eventData?.participatingSectionBgColor} />
            </div>
          )
          :
          <div>
            <ParticipatingUniversities
              universitydata={eventData?.participatingSection}
              univertitle={eventData?.participatingSectionTitle}
              universitybackcolor={eventData?.participatingSectionBgColor}
            />
          </div>
      )}
      {eventData?.aboutSection && (
        <div>
          <AboutQut
            aboutdata={eventData?.aboutSection}
          />
        </div>
      )}
      {eventData?.whyChooseSection && (
        <div>
          <WhyChoose
            whyChoosedata={eventData?.whyChooseSection}
            jotformId={eventData?.meta?.jotforms[0]?.jotformid}  externalLink ={eventData?.externalLink} />
        </div>
      )}
      {eventData?.participationCoursesSectionNew && (
        <div>
          <PopularCourses
            coursedata={eventData?.participationCoursesSectionNew}
          />
        </div>
      )}
      {eventData?.howToAttendSection && (
        <div>
          <HowToAttendEvent
            howToAttendEventData={eventData?.howToAttendSection}
          />
        </div>
      )}
      <GrabChanceSection eventData={eventData} />

      {router.asPath.includes('/company/')
        ? eventData?.benefitsSection && (
          <div>
            <Benefitsofattentadmissionday
              benefitdata={eventData?.benefitsSection}
            />
          </div>
        )
        : eventData?.whyStudySection && (
          <div>
            <Whystudycontry whystudydata={eventData?.whyStudySection}
              jotformId={eventData?.meta?.jotforms[0]?.jotformid}  externalLink={eventData?.externalLink}/>
          </div>
        )}

      {eventData?.whyChooseKc && (
        <div>
          <WhyChoosKcStudyAbroad data={eventData?.whyChooseKc} />
        </div>
      )}
      <AccomplishSection eventData={eventData} />
      {eventData?.studentsSaySection && (
        <div
          style={{
            background:
              eventData?.studentsSaySection?.sectionBgColor || '#EEF2FB',
          }}
        >
          <EduFairStudentTestimonials data={eventData?.studentsSaySection} />
        </div>
      )}

      {eventData?.kcNumbersSection && (
        <div>
          <EduFairKcByNumber data={eventData?.kcNumbersSection} />
        </div>
      )}

      {eventData?.faqSection && (
        <div>
          <StudiesFAQ faqdata={eventData?.faqSection} />
        </div>
      )}

      {eventData?.footer && (
        <div>
          <EduFairFooterCommon
            data={eventData?.footer}
            jotformId={eventData?.meta?.jotforms[0]?.jotformid}
            externalLink={eventData?.externalLink}
          />
        </div>
      )}
    </>
  );
};

export default AdmissionsDayLanding;
